<div class="container-fluid common-pages-banner">
    <div class="container">
        <div class="tg-theme-heading">
            <h1 class="h1tags">About us</h1>
        </div>
    </div>
</div>

<div class="col-md-12 breaeea">

	<ul class="breadcrumb">
		<li><a routerLink="/">Home</a></li>
		 <li>About Us</li>
	</ul>

</div>

<div class="container-fluid paddEqual" *ngIf="propertysnapshot">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-xl-7">
                <div class="about_content">
                    <span class="large" [innerHtml]="data"></span>
                    <ul class="ab_counting">
                        <li class="list-inline-item">
                            <div class="about_counting">
                                <div class="icon"><span class="ti-list"></span></div>
                                <div class="details">
                                    <h2 style="font-size: 20px; color: #484848; font-weight: 700; margin-bottom: 0;">{{propertysnapshot.property_listed}}+</h2>
                                    <p>Properties Listed</p>
                                </div>
                            </div>
                        </li>
                        <li class="list-inline-item">
                            <div class="about_counting">
                                <div class="icon"><span class="ti-location-pin"></span></div>
                                <div class="details">
                                    <h2 style="font-size: 20px; color: #484848; font-weight: 700; margin-bottom: 0;">{{propertysnapshot.property_locations}}+</h2>
                                    <p>Locations</p>
                                </div>
                            </div>
                        </li>
                        <li class="list-inline-item">
                            <div class="about_counting">
                                <div class="icon"><span class="ti-user"></span></div>
                                <div class="details">
                                    <h2 style="font-size: 20px; color: #484848; font-weight: 700; margin-bottom: 0;">{{propertysnapshot.property_buyers}}+</h2>
                                    <p>Buyers</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-xl-5">
                <div class="about_thumb">
                    <img class="img-fluid w100" src="assets/images/about-us-page.jpg" alt="1.jpg">
                </div>
            </div>
        </div>
    </div>
</div>